export interface FilterTypes {
  orderOwner: string[];
  accountName?: string[];
  createdBy?: string[];
  orderType: string[];
  status?: string[];
  clientName: string[];
}

export interface FilterOptions {
  createdBy: { label: string; value: string }[];
  orderType: { label: string; value: string }[];
  accountName: { label: string; value: string }[];
  orderOwner: { label: string; value: string }[];
  clientName: { label: string; value: string }[];
}

export const FilterSummary = {
  orderOwner: 'All users',
  orderType: 'All',
  accountName: 'All',
  createdBy: 'All users',
  clientName: 'All Clients'
};
